import { AccountBalanceWallet } from '@mui/icons-material';
import {
    Card,
    Grid,
    List,
    ListItem,
    ListItemIcon,
    ListItemText,
} from '@mui/material';
import React from 'react';
import * as Yup from 'yup';
import Screen from '../../components/fragments/Screen';
import { useSnackbar } from 'notistack';
import {
    useCreateListDataMutation,
    useGetListDataQuery,
} from '../../api/apiSlice';
import FormikButton from '../../components/formik/FormikButton';
import FormikInput from '../../components/formik/FormikInput';
import Form from '../../components/utilities/Form';
import errorSnackbar from '../../utils/errorSnackbar';

const validate = Yup.object().shape({
    email: Yup.string().email().required().label('Email Adress'),
    start: Yup.string().required().label('Start Date'),
    end: Yup.string().required().label('End Date'),
});

export default function ContributionStatementScreen() {
    const { enqueueSnackbar } = useSnackbar();
    const { data: price } = useGetListDataQuery(
        { list: 'pricing' },
        { refetchOnMountOrArgChange: true }
    );
    const [requestStatement, { isLoading }] = useCreateListDataMutation();

    return (
        <Screen title="Statement">
            <Grid item xs={12}>
                <Form
                    validationSchema={validate}
                    onSubmit={async (vals) => {
                        const { error, data } = await requestStatement({
                            list: '/contribution/statement',
                            body: {
                                ...vals,
                                start: vals.start.replaceAll('-', '/'),
                                end: vals.end.replaceAll('-', '/'),
                            },
                        });

                        errorSnackbar(error, enqueueSnackbar);

                        if (data) {
                            enqueueSnackbar('Booking successful');
                        }
                    }}
                    initialValues={{ email: '', start: '', end: '' }}
                >
                    <FormikInput name="email" placeholder="Email" />
                    <div style={{ display: 'flex', width: '100%' }}>
                        <FormikInput
                            label="From"
                            name="start"
                            type="date"
                            placeholder="From"
                            sx={{ ml: 0.5 }}
                        />
                        <FormikInput
                            label="To"
                            name="end"
                            type="date"
                            placeholder="To"
                            sx={{ ml: 0.5 }}
                        />
                    </div>
                    <Card sx={{ my: 1 }} variant="outlined">
                        <List>
                            <ListItem>
                                <ListItemIcon>
                                    <AccountBalanceWallet />
                                </ListItemIcon>
                                <ListItemText primary={`KSH ${price} Charge`} />
                            </ListItem>
                        </List>
                    </Card>

                    <div className="d-flex justify-content-end">
                        <FormikButton loading={isLoading} variant="contained">
                            Submit
                        </FormikButton>
                    </div>
                </Form>
            </Grid>
        </Screen>
    );
}
